import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { useState } from "react";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { Tasks, Wallet } from "../../types/General";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useAddWalletRefundMutation } from "../../services/wallet";
import { showError, showToast } from "../../constants/toasts";
import { getErrorMessage } from "../../types/api";

interface WalletListProps {
  rows: Wallet[];
  isLoading: boolean;
  count: number;
  page: number;
  onPageChange: (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => void;
  onRefresh?: () => void;
}

function WalletList({
  rows,
  isLoading,
  count,
  page,
  onPageChange,
  onRefresh,
}: WalletListProps) {
  const hidden: string[] = [];
  const navigate = useNavigate();
  const [payWithWallet] = useAddWalletRefundMutation();
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<Wallet | null>(null);

  const handleOpenConfirmDialog = (row: Wallet) => {
    setSelectedRow(row);
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
    setSelectedRow(null);
  };

  const handleConfirmPayment = async () => {
    if (!selectedRow) return;

    try {
      const response = await payWithWallet({
        data: {
          bookingId: selectedRow.bookingId._id,
        },
      }).unwrap();

      if (response?.statusCode === 200) {
        showToast("Payment processed successfully");
        handleCloseConfirmDialog();
        onRefresh?.();
      }
    } catch (error: unknown) {
      showError(getErrorMessage(error, "Failed to process payment"));
    }
  };

  const columns: GridColDef<Wallet>[] = [
    {
      flex: 1,
      minWidth: 150,
      field: "employerId",
      headerName: "Employer Details",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div
            className="user_block click_action"
            onClick={() =>
              navigate(`/manage-employers/detail/${row?.employerId?._id}`)
            }
          >
            <figure>
              <img
                src={
                  row?.employerId?.image ||
                  "/static/images/user_placeholder.png"
                }
                alt=""
              />
            </figure>
            <p>
              <b>{`${row.employerId?.firstName} ${row.employerId?.lastName}`}</b>
              <span>{row.employerId?.email || "-"}</span>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "freelancerId",
      headerName: "Freelancer Details",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div
            className="user_block click_action"
            onClick={() =>
              navigate(`/manage-freelancer/detail/${row?.freelancerId?._id}`)
            }
          >
            <figure>
              <img
                src={
                  row?.freelancerId?.image ||
                  "/static/images/user_placeholder.png"
                }
                alt=""
              />
            </figure>
            <p>
              <b>{`${row?.freelancerId?.firstName} ${row?.freelancerId?.lastName}`}</b>
              <span>{row?.freelancerId?.email || "-"}</span>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "category",
      headerName: "Category",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div>
            <p>{row?.categoryId?.name}</p>
            <p>{row?.subCategoryId?.name}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "createdAt",
      headerName: "Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div>
            <p>{moment(row?.createdAt).format("DD/MM/YYYY hh:mm:ss A")}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 120,
      field: "amount",
      headerName: "Sub Amount",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <p className="c_primary">
            <strong>AED {Number(row?.bookingId?.subTotal).toFixed(2)}</strong>
          </p>
        );
      },
    },
    {
      flex: 1,
      minWidth: 120,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <Button
            className="btn sm btn_primary"
            onClick={() => handleOpenConfirmDialog(row)}
          >
            Pay
          </Button>
        );
      },
    },
  ];
  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={rows}
          loading={isLoading}
          count={count}
          page={page}
          onPageChange={onPageChange}
        />
      </div>

      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="payment-confirmation-dialog"
      >
        <DialogTitle id="payment-confirmation-dialog">
          Confirm Payment
        </DialogTitle>
        <DialogContent>
          Are you sure you want to pay to freelancer with wallet?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseConfirmDialog}
            style={{ color: "#BF2F17" }}
          >
            No
          </Button>
          <Button
            onClick={handleConfirmPayment}
            style={{ color: "#BF2F17" }}
            // variant=""
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default WalletList;
